import { webSlice } from "../../../webSlice";

export const armdimxxWebSlice = webSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    previewDeclaracion: builder.mutation({
      query: ({ docId }) => ({
        url: `/Modimpxx/Nacional/Armdimxx/preview-declaracion/${docId}`,
        method: "GET",
        headers: { Accept: "text/html" },
        responseHandler: (response) => response.blob(),
      }),
    }),
    getPdfProformaDim: builder.mutation({
      query: ({ DOCNROXX }) => ({
        url: `/Modimpxx/Nacional/Armdimxx/getPdfProformaDim/${DOCNROXX}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  usePreviewDeclaracionMutation,
  useGetPdfProformaDimMutation,
} = armdimxxWebSlice;
